import { Component, OnInit, Input } from "@angular/core";
import { PaymentTypeDisplay } from "../../../../payments/models/paymentItem.model";

@Component({
    selector: "payment-display-item",
    templateUrl: "./payment-display-item.component.html",
    styleUrls: ["./payment-display-item.component.scss"],
    standalone: false
})
export class PaymentDisplayItemComponent implements OnInit {
    @Input() cashItems: PaymentTypeDisplay;
    @Input() nonCashItems: PaymentTypeDisplay;
    @Input() isUsed: boolean;

    get hasCash(): boolean {
        if (this.cashItems === undefined || this.cashItems === null) return false;
        return this.cashItems.cashAmount !== undefined && this.cashItems.cashAmount !== null && this.cashItems.cashAmount > 0;
    }    

    get hasInstruments(): boolean {
        if (this.nonCashItems === undefined || this.nonCashItems === null) return false;
        return this.nonCashItems.instruments !== undefined && this.nonCashItems.instruments !== null &&this.nonCashItems.instruments.length > 0;
    }

    constructor() { }

    ngOnInit() {
    }

}
